import { h, useEffect, useState } from '@lukekaalim/act';

import classes from './App.module.css';
import black_logo from '../../design/black_logo.png';
import { Background } from './components/Background';

import perspectiveLogo from './assets/logo_perspective.png';
import instagramLogo from './assets/Instagram_Glyph_Gradient.png';
import blueskyLogo from './assets/bluesky_media_kit_logo_transparent_1.png';

import { html } from '@lukekaalim/act-web';

export const App = () => {
  return h('div', { className: classes.app }, [
    h(Background),
    h(html.div, { className: classes.spacerSmall }),
    h(html.div, { className: classes.cardContainer }, [
      h('div', { className: classes.card }, [
        h('div', { className: classes.introduction }, [
          h('div', { className: classes.iconColumn }, h('img', { className: classes.icon, src: black_logo })),
          h('div', { className: classes.textColumn }, [
            h('h1', { className: classes.title }, h('a', { href: 'https://kosmod.app' }, 'kosmod.app')),
            h('h2', { className: classes.subtitle }, `Virtual Tabletop Gaming`),
            h('p', { className: classes.description }, `Currently under development. Check back soon!`),
          ])
        ]),
      ]),
    ]),
    h(html.div, { className: classes.spacerBig }),
    h(html.div, { className: classes.cardContainer }, [
      h('div', { className: classes.card }, [
        h('div', { className: classes.social }, [
          h('h2', {}, `Follow us!`),
          h('p', {}, [
          `Follow development on your social media platform of choice for News, Dev-Blogs, updates, and `,
          h('strong', {}, `Beta invitations.`)
          ]),
          h('nav', {}, h('ul', { className: classes.socialList }, [
            // h('li', { className: classes.socialEntryWIP }, `Discord`),
            // h('li', { className: classes.socialEntryWIP }, `Twitter`),
            h('li', {},
              h('a', { href: 'https://bsky.app/profile/kosmod-dev.bsky.social' },
                h('img', { className: classes.socialImage, src: blueskyLogo, title: 'Bluesky' }))),
            // h('li', { className: classes.socialEntryWIP }, `Mastodon`),
            // h('li', { className: classes.socialEntryWIP }, `Youtube`),
            h('li', {},
              h('a', { href: 'https://www.instagram.com/kosmod.app' },
                h('img', { className: classes.socialImage, src: instagramLogo, title: 'Instagram' }))),
          ]))
        ]),
      ]),
    ]),
    h('footer', { className: classes.footer }, [
      h('img', { className: classes.footerImage, src: perspectiveLogo }),
      `© Kosmod Studio ${new Date().getFullYear()}`
    ]),
  ])
};